// import React, { useRef, useState } from "react";

// export const InvestigationsHistory = ({
//   setPatientMedicationInfo,
//   patientMedicationInfo,
// }) => {
//   const [haveDisabilityForPain, setHaveDisabilityForPain] = useState("No");
//   const inputFileRef = useRef(null);
//   const handleFileChange = (event) => {
//     const { name, files } = event.target;
//     const selectedFile = files[0]; // Get the first file

//     setPatientMedicationInfo((prev) => ({
//       ...prev,
//       [name]: selectedFile,
//     }));
//   };

//   return (
//     <>
//       <div className="px-4 py-3 mb-5">
//         <div className="w-full">
//           <div className="my-2 flex flex-col gap-4 p-6 w-[40%] rounded-lg bg-whit shadow-md border border-[#0A1E44]">
//             <p className="font-mainFont font-[600] text-[1.1vw] text-[#333333]">
//               Do you have any imaging to upload?
//             </p>
//             <div className="flex justify-start items-center gap-4">
//               <button
//                 onClick={() => {
//                   setHaveDisabilityForPain("Yes");
//                   // setPatientMedicationInfo({
//                   //   ...patientMedicationInfo,
//                   //   takingBloodThinner: "Yes",
//                   // });
//                 }}
//                 className={`text-[#333333] ${
//                   haveDisabilityForPain === "Yes"
//                     ? "text-[#fff] BTNGradientBg"
//                     : "text-black bg-white"
//                 }  px-8 py-1 text-[1vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper`}
//               >
//                 Yes
//               </button>
//               <button
//                 onClick={() => {
//                   setHaveDisabilityForPain("No");
//                   setPatientMedicationInfo({
//                     ...patientMedicationInfo,
//                     takingBloodThinner: "No",
//                   });
//                 }}
//                 className={`text-[#333333]   px-8 py-1 text-[1vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
//                   haveDisabilityForPain === "No"
//                     ? "text-[#fff] BTNGradientBg"
//                     : "text-black bg-white"
//                 }`}
//               >
//                 No
//               </button>
//             </div>
//           </div>

//           {haveDisabilityForPain === "Yes" && (
//             <>
//               <div class="relative overflow-x-auto">

//                 <div className="w-full">
//                   <div className="flex justify-center items-center w-full">
//                     <div className="flex-1 min-w-[10dvw]  py-4 px-3">
//                       <h3 className="text-[#333333] font-[600] text-[1.4dvw] text-start">
//                         Speciality
//                       </h3>
//                     </div>
//                     <div className="flex-1 min-w-[10dvw]  py-4 px-3">
//                       <h3 className="text-[#333333] font-[600] text-[1.4dvw] text-start">
//                         Name
//                       </h3>
//                     </div>
//                     <div className="flex-1 min-w-[10dvw]  py-4 px-3">
//                       <h3 className="text-[#333333] font-[600] text-[1.4dvw] text-start">
//                         Treatments
//                       </h3>
//                     </div>
//                     <div className="flex-1 min-w-[10dvw]  py-4 px-3">
//                       <h3 className="text-[#333333] font-[600] text-[1.4dvw] text-start">
//                         Pain relief
//                       </h3>
//                     </div>
//                     <div className="flex-1 min-w-[10dvw]  py-4 px-3">
//                       <h3 className="text-[#333333] font-[600] text-[1.4dvw] text-start">
//                         Last Dates
//                       </h3>
//                     </div>
//                     <div className="flex-1 min-w-[10dvw]  py-4 px-3">
//                       <h3 className="text-[#333333] font-[600] text-[1.4dvw] text-start">
//                         Upload Files
//                       </h3>
//                     </div>
//                   </div>
//                   <div className="flex flex-col gap-3 w-full mt-4">
//                     <div className="flex w-full">
//                       <div className="py-4 px-3 min-w-[10dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD]">
//                         <h3 className="text-black font-[500] text-[.9dvw]">
//                           Acupuncturist
//                         </h3>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           placeholder="Enter Name"
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           placeholder="Enter Treatment"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
//                         <select className="bg-transparent border-none outline-none focus:border-none active:border-none w-full">
//                           <option>Select</option>
//                           <option>Pain relief 1</option>
//                           <option>Pain relief 2</option>
//                           <option>Pain relief 3</option>
//                           <option>Pain relief 4</option>
//                         </select>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           type="date"
//                         />
//                       </div>
//                       <div className="flex-1  px-3 min-w-[10dvw]  ">
//                         <button
//                           onClick={() => inputFileRef.current.click()}
//                           className="flex justify-center items-center w-full rounded-full BTNGradientBg py-4 gap-3 text-[#fff]"
//                         >
//                           <span>
//                             <svg
//                               width="11"
//                               height="14"
//                               viewBox="0 0 11 14"
//                               fill="none"
//                               xmlns="http://www.w3.org/2000/svg"
//                             >
//                               <path
//                                 d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
//                                 fill="#FBFBFB"
//                               />
//                               <path
//                                 d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
//                                 fill="#FBFBFB"
//                               />
//                             </svg>
//                           </span>
//                           Upload File{" "}
//                           <input
//                             type="file"
//                             name="acupuncturist_FILE"
//                             onChange={handleFileChange}
//                             ref={inputFileRef}
//                             hidden
//                           />
//                         </button>

//                         {/* <input
//                           type="file"
//                           className="flex justify-center items-center w-full rounded-full btnGraident py-4 gap-3 text-[#333333]"
//                           name="acupuncturist_FILE"
//                           onChange={handleFileChange}
//                         /> */}
//                       </div>
//                     </div>
//                     <div className="flex w-full">
//                       <div className="py-4 px-3 min-w-[10dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD]">
//                         <h3 className="text-black font-[500] text-[.9dvw]">
//                           Neurosurgeon
//                         </h3>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           placeholder="Enter Name"
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           placeholder="Enter Treatment"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
//                         <select className="bg-transparent border-none outline-none focus:border-none active:border-none w-full">
//                           <option>Select</option>
//                           <option>Pain relief 1</option>
//                           <option>Pain relief 2</option>
//                           <option>Pain relief 3</option>
//                           <option>Pain relief 4</option>
//                         </select>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           type="date"
//                         />
//                       </div>
//                       <div className="flex-1  px-3 min-w-[10dvw]  ">
//                         <button
//                           onClick={() => inputFileRef.current.click()}
//                           className="flex justify-center items-center w-full rounded-full BTNGradientBg py-4 gap-3 text-[#fff]"
//                         >
//                           <span>
//                             <svg
//                               width="11"
//                               height="14"
//                               viewBox="0 0 11 14"
//                               fill="none"
//                               xmlns="http://www.w3.org/2000/svg"
//                             >
//                               <path
//                                 d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
//                                 fill="#FBFBFB"
//                               />
//                               <path
//                                 d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
//                                 fill="#FBFBFB"
//                               />
//                             </svg>
//                           </span>
//                           Upload File{" "}
//                           <input
//                             type="file"
//                             name="neurosurgeon_FILE"
//                             onChange={handleFileChange}
//                             ref={inputFileRef}
//                             hidden
//                           />
//                         </button>

//                         {/* <input
//                           type="file"
//                           className="flex justify-center items-center w-full rounded-full btnGraident py-4 gap-3 text-[#333333]"
//                           name="neurosurgeon_FILE"
//                           onChange={handleFileChange}
//                         /> */}
//                       </div>
//                     </div>

//                     <div className="flex w-full">
//                       <div className="py-4 px-3 min-w-[10dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD]">
//                         <h3 className="text-black font-[500] text-[.9dvw]">
//                           Chiropractor
//                         </h3>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           placeholder="Enter Name"
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           placeholder="Enter Treatment"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
//                         <select className="bg-transparent border-none outline-none focus:border-none active:border-none w-full">
//                           <option>Select</option>
//                           <option>Pain relief 1</option>
//                           <option>Pain relief 2</option>
//                           <option>Pain relief 3</option>
//                           <option>Pain relief 4</option>
//                         </select>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           type="date"
//                         />
//                       </div>
//                       <div className="flex-1  px-3 min-w-[10dvw]  ">
//                         <button
//                           onClick={() => inputFileRef.current.click()}
//                           className="flex justify-center items-center w-full rounded-full BTNGradientBg py-4 gap-3 text-[#fff]"
//                         >
//                           <span>
//                             <svg
//                               width="11"
//                               height="14"
//                               viewBox="0 0 11 14"
//                               fill="none"
//                               xmlns="http://www.w3.org/2000/svg"
//                             >
//                               <path
//                                 d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
//                                 fill="#FBFBFB"
//                               />
//                               <path
//                                 d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
//                                 fill="#FBFBFB"
//                               />
//                             </svg>
//                           </span>
//                           Upload File{" "}
//                           <input
//                             type="file"
//                             name="chiropractor_FILE"
//                             onChange={handleFileChange}
//                             ref={inputFileRef}
//                             hidden
//                           />
//                         </button>

//                         {/* <input
//                           type="file"
//                           className="flex justify-center items-center w-full rounded-full btnGraident py-4 gap-3 text-[#333333]"
//                           name="chiropractor_FILE"
//                           onChange={handleFileChange}
//                         /> */}
//                       </div>
//                     </div>

//                     <div className="flex w-full">
//                       <div className="py-4 px-3 min-w-[10dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD]">
//                         <h3 className="text-black font-[500] text-[.9dvw]">
//                           Orthopedic Surgeon
//                         </h3>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           placeholder="Enter Name"
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           placeholder="Enter Treatment"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
//                         <select className="bg-transparent border-none outline-none focus:border-none active:border-none w-full">
//                           <option>Select</option>
//                           <option>Pain relief 1</option>
//                           <option>Pain relief 2</option>
//                           <option>Pain relief 3</option>
//                           <option>Pain relief 4</option>
//                         </select>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           type="date"
//                         />
//                       </div>
//                       <div className="flex-1  px-3 min-w-[10dvw]  ">
//                         <button
//                           onClick={() => inputFileRef.current.click()}
//                           className="flex justify-center items-center w-full rounded-full BTNGradientBg py-4 gap-3 text-[#fff]"
//                         >
//                           <span>
//                             <svg
//                               width="11"
//                               height="14"
//                               viewBox="0 0 11 14"
//                               fill="none"
//                               xmlns="http://www.w3.org/2000/svg"
//                             >
//                               <path
//                                 d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
//                                 fill="#FBFBFB"
//                               />
//                               <path
//                                 d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
//                                 fill="#FBFBFB"
//                               />
//                             </svg>
//                           </span>
//                           Upload File{" "}
//                           <input
//                             type="file"
//                             name="orthopedic_FILE"
//                             onChange={handleFileChange}
//                             ref={inputFileRef}
//                             hidden
//                           />
//                         </button>
//                         {/* <input
//                           type="file"
//                           className="flex justify-center items-center w-full rounded-full btnGraident py-4 gap-3 text-[#333333]"
//                           name="orthopedic_FILE"
//                           onChange={handleFileChange}
//                         /> */}
//                       </div>
//                     </div>

//                     <div className="flex w-full">
//                       <div className="py-4 px-3 min-w-[10dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD]">
//                         <h3 className="text-black font-[500] text-[.9dvw]">
//                           Rheumatologist
//                         </h3>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           placeholder="Enter Name"
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           placeholder="Enter Treatment"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
//                         <select className="bg-transparent border-none outline-none focus:border-none active:border-none w-full">
//                           <option>Select</option>
//                           <option>Pain relief 1</option>
//                           <option>Pain relief 2</option>
//                           <option>Pain relief 3</option>
//                           <option>Pain relief 4</option>
//                         </select>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           type="date"
//                         />
//                       </div>
//                       <div className="flex-1  px-3 min-w-[10dvw]  ">
//                         <button
//                           onClick={() => inputFileRef.current.click()}
//                           className="flex justify-center items-center w-full rounded-full BTNGradientBg py-4 gap-3 text-[#fff]"
//                         >
//                           <span>
//                             <svg
//                               width="11"
//                               height="14"
//                               viewBox="0 0 11 14"
//                               fill="none"
//                               xmlns="http://www.w3.org/2000/svg"
//                             >
//                               <path
//                                 d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
//                                 fill="#FBFBFB"
//                               />
//                               <path
//                                 d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
//                                 fill="#FBFBFB"
//                               />
//                             </svg>
//                           </span>
//                           Upload File{" "}
//                           <input
//                             type="file"
//                             name="rheumatologist_FILE"
//                             onChange={handleFileChange}
//                             ref={inputFileRef}
//                             hidden
//                           />
//                         </button>

//                       </div>
//                     </div>

//                     <div className="flex w-full">
//                       <div className="py-4 px-3 min-w-[10dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD]">
//                         <h3 className="text-black font-[500] text-[.9dvw]">
//                           Internist
//                         </h3>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           placeholder="Enter Name"
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           placeholder="Enter Treatment"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
//                         <select className="bg-transparent border-none outline-none focus:border-none active:border-none w-full">
//                           <option>Select</option>
//                           <option>Pain relief 1</option>
//                           <option>Pain relief 2</option>
//                           <option>Pain relief 3</option>
//                           <option>Pain relief 4</option>
//                         </select>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           type="date"
//                         />
//                       </div>
//                       <div className="flex-1  px-3 min-w-[10dvw]  ">
//                         <button
//                       onClick={() => inputFileRef.current.click()}
//                       className="flex justify-center items-center w-full rounded-full BTNGradientBg py-4 gap-3 text-[#fff]"
//                     >
//                       <span>
//                         <svg
//                           width="11"
//                           height="14"
//                           viewBox="0 0 11 14"
//                           fill="none"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path
//                             d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
//                             fill="#FBFBFB"
//                           />
//                           <path
//                             d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
//                             fill="#FBFBFB"
//                           />
//                         </svg>
//                       </span>
//                       Upload File{" "}
//                       <input type="file" name="internist_FILE"
//                           onChange={handleFileChange} ref={inputFileRef} hidden />
//                     </button>

//                       </div>
//                     </div>

//                     <div className="flex w-full">
//                       <div className="py-4 px-3 min-w-[10dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD]">
//                         <h3 className="text-black font-[500] text-[.9dvw]">
//                           Physical Therapist
//                         </h3>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           placeholder="Enter Name"
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           placeholder="Enter Treatment"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
//                         <select className="bg-transparent border-none outline-none focus:border-none active:border-none w-full">
//                           <option>Select</option>
//                           <option>Pain relief 1</option>
//                           <option>Pain relief 2</option>
//                           <option>Pain relief 3</option>
//                           <option>Pain relief 4</option>
//                         </select>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           type="date"
//                         />
//                       </div>
//                       <div className="flex-1  px-3 min-w-[10dvw]  ">
//                         <button
//                           onClick={() => inputFileRef.current.click()}
//                          className="flex justify-center items-center w-full rounded-full BTNGradientBg py-4 gap-3 text-[#fff]"
//                         >
//                           <span>
//                             <svg
//                               width="11"
//                               height="14"
//                               viewBox="0 0 11 14"
//                               fill="none"
//                               xmlns="http://www.w3.org/2000/svg"
//                             >
//                               <path
//                                 d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
//                                 fill="#FBFBFB"
//                               />
//                               <path
//                                 d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
//                                 fill="#FBFBFB"
//                               />
//                             </svg>
//                           </span>
//                           Upload File{" "}
//                           <input
//                             type="file"
//                             name="physical_FILE"
//                             onChange={handleFileChange}
//                             ref={inputFileRef}
//                             hidden
//                           />
//                         </button>

//                       </div>
//                     </div>

//                     <div className="flex w-full">
//                       <div className="py-4 px-3 min-w-[10dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD]">
//                         <h3 className="text-black font-[500] text-[.9dvw]">
//                           Neurologist
//                         </h3>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           placeholder="Enter Name"
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none  w-full"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] border-l-0 bg-white border-2 border-[#CDCDCD]">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           placeholder="Enter Treatment"
//                         />
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
//                         <select className="bg-transparent border-none outline-none focus:border-none active:border-none w-full">
//                           <option>Select</option>
//                           <option>Pain relief 1</option>
//                           <option>Pain relief 2</option>
//                           <option>Pain relief 3</option>
//                           <option>Pain relief 4</option>
//                         </select>
//                       </div>
//                       <div className="flex-1 py-4 px-3 min-w-[10dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
//                         <input
//                           className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
//                           type="date"
//                         />
//                       </div>
//                       <div className="flex-1  px-3 min-w-[10dvw]  ">
//                         <button
//                           onClick={() => inputFileRef.current.click()}
//                           className="flex justify-center items-center w-full rounded-full BTNGradientBg py-4 gap-3 text-[#fff]"
//                         >
//                           <span>
//                             <svg
//                               width="11"
//                               height="14"
//                               viewBox="0 0 11 14"
//                               fill="none"
//                               xmlns="http://www.w3.org/2000/svg"
//                             >
//                               <path
//                                 d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
//                                 fill="#FBFBFB"
//                               />
//                               <path
//                                 d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
//                                 fill="#FBFBFB"
//                               />
//                             </svg>
//                           </span>
//                           Upload File{" "}
//                           <input
//                             type="file"
//                             name="neurologist_FILE"
//                             onChange={handleFileChange}
//                             ref={inputFileRef}
//                             hidden
//                           />
//                         </button>
//                         {/* <input
//                           type="file"
//                           className="flex justify-center items-center w-full rounded-full btnGraident py-4 gap-3 text-[#333333]"
//                           name="neurologist_FILE"
//                           onChange={handleFileChange}
//                         /> */}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="my-8">
//                 <h3 className="font-mainFont font-[600] text-[#333333] text-[1.1vw]">
//                   Other Diagnostic Testing
//                 </h3>
//                 <div className="flex justify-start w-full my-3 gap-3">
//                   <div className="flex-1 flex flex-col gap-3">
//                     <label className="font-mainFont font-[600] text-[#333333] text-[1vw]">
//                       List the names of any previous pain management:
//                     </label>
//                     <input
//                       className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] text-[1vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
//                       placeholder="Enter the names of any previous pain management method"
//                     />
//                   </div>
//                   <div className="flex-1 flex flex-col gap-3">
//                     <label className="font-mainFont font-[600] text-[#333333] text-[1vw]">
//                       Physicians you have seen in the past:
//                     </label>
//                     <input
//                       className=" w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] text-[1vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
//                       placeholder="Enter the names of any previous Physicians"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

import { Tooltip } from "@mui/material";
import React, { useRef, useState } from "react";
import {
  MAX_INVESTIGATION_FILES,
  normalizeInvestigationFiles,
  canAddInvestigationFiles,
  getInvestigationFileLabel,
  appendInvestigationFiles,
  removeInvestigationFileAt,
  investigationFileInputKey,
  INVESTIGATION_UPLOAD_COLUMN_WHITE,
  INVESTIGATION_ENTRY_CLASS,
  INVESTIGATION_FILE_LIST_CLASS,
  INVESTIGATION_FILE_CHIP_CLASS,
} from "../../utils/investigationFiles";
import "../../styles/investigationUploadRows.css";

export const InvestigationsHistory = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [haveDisabilityForPain, setHaveDisabilityForPain] = useState("No");
  const acupuncturistFileRef = useRef(null);
  const neurosurgeonFileRef = useRef(null);
  const chiropractorFileRef = useRef(null);
  const orthopedicFileRef = useRef(null);
  const rheumatologistFileRef = useRef(null);
  const internistFileRef = useRef(null);
  const physicalFileRef = useRef(null);
  const neurologistFileRef = useRef(null);
  const psychiatristFileRef = useRef(null);

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (!files?.length) return;
    setPatientMedicationInfo((prev) => ({
      ...prev,
      [name]: appendInvestigationFiles(prev[name], files),
    }));
    event.target.value = "";
  };

  const clearUploadedFile = (fieldName, index) => {
    setPatientMedicationInfo((prev) => ({
      ...prev,
      [fieldName]: removeInvestigationFileAt(prev[fieldName], index),
    }));
  };

  const uploadButtonLabel = (fieldName) => {
    const count = normalizeInvestigationFiles(patientMedicationInfo?.[fieldName]).length;
    return count > 0 ? `Upload File (${count}/${MAX_INVESTIGATION_FILES})` : "Upload File";
  };

  const renderSelectedFileLine = (fieldName) => {
    const files = normalizeInvestigationFiles(patientMedicationInfo?.[fieldName]);
    if (!files.length) return null;
    return (
      <div className={INVESTIGATION_FILE_LIST_CLASS}>
        {files.map((entry, index) => {
          const label = getInvestigationFileLabel(entry);
          return (
            <div
              key={`${fieldName}-${index}-${label}`}
              className={`${INVESTIGATION_FILE_CHIP_CLASS} font-mainFont`}
              title={label}
            >
              <span>{label}</span>
              <button
                type="button"
                aria-label="Remove file"
                onClick={() => clearUploadedFile(fieldName, index)}
              >
                ×
              </button>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div className="px-4 py-3 mb-5">
        <div className="w-full">
          <div className="my-2 flex flex-col gap-4 p-6 w-full sm:w-[40%] rounded-lg bg-white shado border border-[#d4d4d4]">
            <div className="flex items-center justify-between">
              <p className="font-mainFont font-[600] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw] text-[#333333]">
                Have you had any investigations done on the current pain?
              </p>
              {/* <div className="relative">
                <a
                  href="https://blume.omegaai.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#fff] BTNGradientBg px-8 py-1 text-[1vw] font-mainFont font-[500] rounded-full transition-all duration-200 ease-linear shadowsForMainWrapper"
                >
                  Blume
                </a>
                <div className="tooltip">Visit Blume for to upload Dicom</div>
              </div> */}
            </div>
            <div className="flex justify-start items-center gap-4">
              <button
                onClick={() => {
                  setHaveDisabilityForPain("Yes");
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    haveImageToUpload: "Yes",
                  });
                }}
                className={`text-[#333333] ${
                  patientMedicationInfo.haveImageToUpload === "Yes"
                    ? "text-[#fff] BTNGradientBg"
                    : "text-black bg-white"
                } px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full transition-all duration-200 ease-linear shadowsForMainWrapper`}
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setHaveDisabilityForPain("No");
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    haveImageToUpload: "No",
                  });
                }}
                className={`text-[#333333] px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full transition-all duration-200 ease-linear shadowsForMainWrapper ${
                  patientMedicationInfo.haveImageToUpload === "No"
                    ? "text-[#fff] BTNGradientBg"
                    : "text-black bg-white"
                }`}
              >
                No
              </button>
            </div>
          </div>

          {patientMedicationInfo.haveImageToUpload === "Yes" && (
            <>
              <div className="relative overflow-x-auto">
                <div className="w-full">
                  <div className="flex 2xl:justify-center xl:justify-center lg:justify-center md:justify-center justify-start items-center w-full">
                    <div className="flex-1 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] py-4 px-3">
                      <h3 className="text-[#333333] font-[600] 2xl:text-[1.4dvw] xl:text-[1.4dvw] lg:text-[1.4dvw] md:text-[1.4dvw] text-[3.5vw] text-start">
                        Speciality
                      </h3>
                    </div>
                    <div className="flex-1 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] py-4 px-3">
                      <h3 className="text-[#333333] font-[600] 2xl:text-[1.4dvw] xl:text-[1.4dvw] lg:text-[1.4dvw] md:text-[1.4dvw] text-[3.5vw] text-start">
                        Name
                      </h3>
                    </div>
                    <div className="flex-1 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] py-4 px-3">
                      <h3 className="text-[#333333] font-[600] 2xl:text-[1.4dvw] xl:text-[1.4dvw] lg:text-[1.4dvw] md:text-[1.4dvw] text-[3.5vw] text-start">
                        Treatments
                      </h3>
                    </div>
                    <div className="flex-1 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] py-4 px-3">
                      <h3 className="text-[#333333] font-[600] 2xl:text-[1.4dvw] xl:text-[1.4dvw] lg:text-[1.4dvw] md:text-[1.4dvw] text-[3.5vw] text-start">
                        Pain relief
                      </h3>
                    </div>
                    <div className="flex-1 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] py-4 px-3">
                      <h3 className="text-[#333333] font-[600] 2xl:text-[1.4dvw] xl:text-[1.4dvw] lg:text-[1.4dvw] md:text-[1.4dvw] text-[3.5vw] text-start">
                        Last Dates
                      </h3>
                    </div>
                    <div className="flex-1 2xl:min-w-[20dvw] xl:min-w-[20dvw] lg:min-w-[20dvw] md:min-w-[20dvw] min-w-[60dvw] py-4 px-3">
                      <h3 className="text-[#333333] font-[600] 2xl:text-[1.4dvw] xl:text-[1.4dvw] lg:text-[1.4dvw] md:text-[1.4dvw] text-[3.5vw] text-start">
                        Upload Files
                      </h3>
                    </div>
                  </div>
                  <div className="flex flex-col gap-3 w-full mt-4">
                    <div className={INVESTIGATION_ENTRY_CLASS}>
                    <div className="investigation-upload-row flex w-full">
                      <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD] flex items-center">
                        <h3 className="text-black font-[500] 2xl:text-[.9dvw] xl:text-[.9dvw] lg:text-[.9dvw] md:text-[.9dvw] text-[3.5vw]">
                          Acupuncturist
                        </h3>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          placeholder="Enter Name"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              acupuncturist: {
                                ...patientMedicationInfo.acupuncturist,
                                name: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.acupuncturist.name}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          placeholder="Enter Treatment"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              acupuncturist: {
                                ...patientMedicationInfo.acupuncturist,
                                treatment: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.acupuncturist.treatment}
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
                        <select
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              acupuncturist: {
                                ...patientMedicationInfo.acupuncturist,
                                painRelief: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.acupuncturist.painRelief}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        >
                          <option>Select</option>
                          <option>Pain relief 1</option>
                          <option>Pain relief 2</option>
                          <option>Pain relief 3</option>
                          <option>Pain relief 4</option>
                        </select>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          type="date"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              acupuncturist: {
                                ...patientMedicationInfo.acupuncturist,
                                date: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.acupuncturist.date}
                        />
                      </div>
                      <div className={INVESTIGATION_UPLOAD_COLUMN_WHITE}>
                        <div className="flex justify-center items-stretch gap-2.5 w-full">
                          <Tooltip title="Create an Account and Upload images">
                            <a
                              href="https://blume.omegaai.com/"
                              target="_blank"
                              className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                            >
                              Upload to Blume
                            </a>
                          </Tooltip>
                          <button
                            type="button"
                            onClick={() =>
                              canAddInvestigationFiles(patientMedicationInfo.acupuncturist_FILE) &&
                              acupuncturistFileRef.current?.click()
                            }
                            disabled={!canAddInvestigationFiles(patientMedicationInfo.acupuncturist_FILE)}
                            className={`flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff] ${
                              !canAddInvestigationFiles(patientMedicationInfo.acupuncturist_FILE)
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          >
                            <span>
                              <svg
                                width="11"
                                height="14"
                                viewBox="0 0 11 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
                                  fill="#FBFBFB"
                                />
                                <path
                                  d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
                                  fill="#FBFBFB"
                                />
                              </svg>
                            </span>
                            {uploadButtonLabel("acupuncturist_FILE")}
                            <input
                              key={investigationFileInputKey(
                                "acupuncturist_FILE",
                                patientMedicationInfo?.acupuncturist_FILE
                              )}
                              type="file"
                              multiple
                              name="acupuncturist_FILE"
                              onChange={handleFileChange}
                              ref={acupuncturistFileRef}
                              hidden
                            />
                          </button>
                          <Tooltip title="Mark as Uploaded">
                            <input
                              className=" w-5 h-5"
                              type="checkbox"
                              value="uploaded"
                              checked={
                                patientMedicationInfo.acupuncturist.isUploaded
                              }
                              onChange={(e) => {
                                setPatientMedicationInfo({
                                  ...patientMedicationInfo,
                                  acupuncturist: {
                                    ...patientMedicationInfo.acupuncturist,
                                    isUploaded:
                                      !patientMedicationInfo.acupuncturist
                                        .isUploaded,
                                  },
                                });
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    {renderSelectedFileLine("acupuncturist_FILE")}
                    </div>

                    <div className={INVESTIGATION_ENTRY_CLASS}>
                    <div className="investigation-upload-row flex w-full">
                      <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD] flex items-center">
                        <h3 className="text-black font-[500] 2xl:text-[.9dvw] xl:text-[.9dvw] lg:text-[.9dvw] md:text-[.9dvw] text-[3.5vw]">
                          Neurosurgeon
                        </h3>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          placeholder="Enter Name"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              neurosurgeon: {
                                ...patientMedicationInfo.rheumatologist,
                                name: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.neurosurgeon.name}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          placeholder="Enter Treatment"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              neurosurgeon: {
                                ...patientMedicationInfo.rheumatologist,
                                treatment: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.neurosurgeon.treatment}
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
                        <select
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              neurosurgeon: {
                                ...patientMedicationInfo.rheumatologist,
                                painRelief: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.neurosurgeon.painRelief}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        >
                          <option>Select</option>
                          <option>Pain relief 1</option>
                          <option>Pain relief 2</option>
                          <option>Pain relief 3</option>
                          <option>Pain relief 4</option>
                        </select>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          type="date"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              neurosurgeon: {
                                ...patientMedicationInfo.rheumatologist,
                                date: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.neurosurgeon.date}
                        />
                      </div>
                      <div className={INVESTIGATION_UPLOAD_COLUMN_WHITE}>
                        <div className="flex justify-center items-stretch gap-2.5 w-full">
                          <Tooltip title="Create an Account and Upload images">
                            <a
                              href="https://blume.omegaai.com/"
                              target="_blank"
                              className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                            >
                              Upload to Blume
                            </a>
                          </Tooltip>
                          <button
                            type="button"
                            onClick={() =>
                              canAddInvestigationFiles(patientMedicationInfo.neurosurgeon_FILE) &&
                              neurosurgeonFileRef.current?.click()
                            }
                            disabled={!canAddInvestigationFiles(patientMedicationInfo.neurosurgeon_FILE)}
                            className={`flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff] ${
                              !canAddInvestigationFiles(patientMedicationInfo.neurosurgeon_FILE)
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          >
                            <span>
                              <svg
                                width="11"
                                height="14"
                                viewBox="0 0 11 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
                                  fill="#FBFBFB"
                                />
                                <path
                                  d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
                                  fill="#FBFBFB"
                                />
                              </svg>
                            </span>
                            {uploadButtonLabel("neurosurgeon_FILE")}
                            <input
                              key={investigationFileInputKey(
                                "neurosurgeon_FILE",
                                patientMedicationInfo?.neurosurgeon_FILE
                              )}
                              type="file"
                              multiple
                              name="neurosurgeon_FILE"
                              onChange={handleFileChange}
                              ref={neurosurgeonFileRef}
                              hidden
                            />
                          </button>
                          <Tooltip title="Mark as Uploaded">
                            <input
                              className=" w-5 h-5"
                              type="checkbox"
                              value="uploaded"
                              checked={
                                patientMedicationInfo.neurosurgeon.isUploaded
                              }
                              onChange={(e) => {
                                setPatientMedicationInfo({
                                  ...patientMedicationInfo,
                                  neurosurgeon: {
                                    ...patientMedicationInfo.neurosurgeon,
                                    isUploaded:
                                      !patientMedicationInfo.neurosurgeon
                                        .isUploaded,
                                  },
                                });
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    {renderSelectedFileLine("neurosurgeon_FILE")}
                    </div>

                    <div className={INVESTIGATION_ENTRY_CLASS}>
                    <div className="investigation-upload-row flex w-full">
                      <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD] flex items-center">
                        <h3 className="text-black font-[500] 2xl:text-[.9dvw] xl:text-[.9dvw] lg:text-[.9dvw] md:text-[.9dvw] text-[3.5vw]">
                          Chiropractor
                        </h3>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          placeholder="Enter Name"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              chiropractor: {
                                ...patientMedicationInfo.chiropractor,
                                name: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.chiropractor.name}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          placeholder="Enter Treatment"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              chiropractor: {
                                ...patientMedicationInfo.chiropractor,
                                treatment: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.chiropractor.treatment}
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
                        <select
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              chiropractor: {
                                ...patientMedicationInfo.chiropractor,
                                painRelief: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.chiropractor.painRelief}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        >
                          <option>Select</option>
                          <option>Pain relief 1</option>
                          <option>Pain relief 2</option>
                          <option>Pain relief 3</option>
                          <option>Pain relief 4</option>
                        </select>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          type="date"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              chiropractor: {
                                ...patientMedicationInfo.chiropractor,
                                date: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.chiropractor.date}
                        />
                      </div>
                      <div className={INVESTIGATION_UPLOAD_COLUMN_WHITE}>
                        <div className="flex justify-center items-stretch gap-2.5 w-full">
                          <Tooltip title="Create an Account and Upload images">
                            <a
                              href="https://blume.omegaai.com/"
                              target="_blank"
                              className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                            >
                              Upload to Blume
                            </a>
                          </Tooltip>
                          <button
                            type="button"
                            onClick={() =>
                              canAddInvestigationFiles(patientMedicationInfo.chiropractor_FILE) &&
                              chiropractorFileRef.current?.click()
                            }
                            disabled={!canAddInvestigationFiles(patientMedicationInfo.chiropractor_FILE)}
                            className={`flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff] ${
                              !canAddInvestigationFiles(patientMedicationInfo.chiropractor_FILE)
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          >
                            <span>
                              <svg
                                width="11"
                                height="14"
                                viewBox="0 0 11 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
                                  fill="#FBFBFB"
                                />
                                <path
                                  d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
                                  fill="#FBFBFB"
                                />
                              </svg>
                            </span>
                            {uploadButtonLabel("chiropractor_FILE")}
                            <input
                              key={investigationFileInputKey(
                                "chiropractor_FILE",
                                patientMedicationInfo?.chiropractor_FILE
                              )}
                              type="file"
                              multiple
                              name="chiropractor_FILE"
                              onChange={handleFileChange}
                              ref={chiropractorFileRef}
                              hidden
                            />
                          </button>
                          <Tooltip title="Mark as Uploaded">
                            <input
                              className=" w-5 h-5"
                              type="checkbox"
                              value="uploaded"
                              checked={
                                patientMedicationInfo.chiropractor.isUploaded
                              }
                              onChange={(e) => {
                                setPatientMedicationInfo({
                                  ...patientMedicationInfo,
                                  chiropractor: {
                                    ...patientMedicationInfo.chiropractor,
                                    isUploaded:
                                      !patientMedicationInfo.chiropractor
                                        .isUploaded,
                                  },
                                });
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    {renderSelectedFileLine("chiropractor_FILE")}
                    </div>

                    <div className={INVESTIGATION_ENTRY_CLASS}>
                    <div className="investigation-upload-row flex w-full">
                      <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD] flex items-center">
                        <h3 className="text-black font-[500] 2xl:text-[.9dvw] xl:text-[.9dvw] lg:text-[.9dvw] md:text-[.9dvw] text-[3.5vw]">
                          Orthopedic Surgeon
                        </h3>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          placeholder="Enter Name"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              orthopedicSurgeon: {
                                ...patientMedicationInfo.rheumatologist,
                                name: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.orthopedicSurgeon.name}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          placeholder="Enter Treatment"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              orthopedicSurgeon: {
                                ...patientMedicationInfo.rheumatologist,
                                treatment: e.target.value,
                              },
                            });
                          }}
                          value={
                            patientMedicationInfo.orthopedicSurgeon.treatment
                          }
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
                        <select
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              orthopedicSurgeon: {
                                ...patientMedicationInfo.rheumatologist,
                                painRelief: e.target.value,
                              },
                            });
                          }}
                          value={
                            patientMedicationInfo.orthopedicSurgeon.painRelief
                          }
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        >
                          <option>Select</option>
                          <option>Pain relief 1</option>
                          <option>Pain relief 2</option>
                          <option>Pain relief 3</option>
                          <option>Pain relief 4</option>
                        </select>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          type="date"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              orthopedicSurgeon: {
                                ...patientMedicationInfo.rheumatologist,
                                date: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.orthopedicSurgeon.date}
                        />
                      </div>
                      <div className={INVESTIGATION_UPLOAD_COLUMN_WHITE}>
                        <div className="flex justify-center items-stretch gap-2.5 w-full">
                          <Tooltip title="Create an Account and Upload images">
                            <a
                              href="https://blume.omegaai.com/"
                              target="_blank"
                              className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                            >
                              Upload to Blume
                            </a>
                          </Tooltip>
                          <button
                            type="button"
                            onClick={() =>
                              canAddInvestigationFiles(patientMedicationInfo.orthopedic_FILE) &&
                              orthopedicFileRef.current?.click()
                            }
                            disabled={!canAddInvestigationFiles(patientMedicationInfo.orthopedic_FILE)}
                            className={`flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff] ${
                              !canAddInvestigationFiles(patientMedicationInfo.orthopedic_FILE)
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          >
                            <span>
                              <svg
                                width="11"
                                height="14"
                                viewBox="0 0 11 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
                                  fill="#FBFBFB"
                                />
                                <path
                                  d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
                                  fill="#FBFBFB"
                                />
                              </svg>
                            </span>
                            {uploadButtonLabel("orthopedic_FILE")}
                            <input
                              key={investigationFileInputKey(
                                "orthopedic_FILE",
                                patientMedicationInfo?.orthopedic_FILE
                              )}
                              type="file"
                              multiple
                              name="orthopedic_FILE"
                              onChange={handleFileChange}
                              ref={orthopedicFileRef}
                              hidden
                            />
                          </button>
                          <Tooltip title="Mark as Uploaded">
                            <input
                              className=" w-5 h-5"
                              type="checkbox"
                              value="uploaded"
                              checked={
                                patientMedicationInfo.orthopedicSurgeon.isUploaded
                              }
                              onChange={(e) => {
                                setPatientMedicationInfo({
                                  ...patientMedicationInfo,
                                  orthopedicSurgeon: {
                                    ...patientMedicationInfo.orthopedicSurgeon,
                                    isUploaded:
                                      !patientMedicationInfo.orthopedicSurgeon
                                        .isUploaded,
                                  },
                                });
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    {renderSelectedFileLine("orthopedic_FILE")}
                    </div>

                    <div className={INVESTIGATION_ENTRY_CLASS}>
                    <div className="investigation-upload-row flex w-full">
                      <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD] flex items-center">
                        <h3 className="text-black font-[500] 2xl:text-[.9dvw] xl:text-[.9dvw] lg:text-[.9dvw] md:text-[.9dvw] text-[3.5vw]">
                          Rheumatologist
                        </h3>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          placeholder="Enter Name"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              rheumatologist: {
                                ...patientMedicationInfo.rheumatologist,
                                name: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.rheumatologist.name}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          placeholder="Enter Treatment"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              rheumatologist: {
                                ...patientMedicationInfo.rheumatologist,
                                treatment: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.rheumatologist.treatment}
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
                        <select
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              rheumatologist: {
                                ...patientMedicationInfo.rheumatologist,
                                painRelief: e.target.value,
                              },
                            });
                          }}
                          value={
                            patientMedicationInfo.rheumatologist.painRelief
                          }
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        >
                          <option>Select</option>
                          <option>Pain relief 1</option>
                          <option>Pain relief 2</option>
                          <option>Pain relief 3</option>
                          <option>Pain relief 4</option>
                        </select>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          type="date"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              rheumatologist: {
                                ...patientMedicationInfo.rheumatologist,
                                date: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.rheumatologist.date}
                        />
                      </div>
                      <div className={INVESTIGATION_UPLOAD_COLUMN_WHITE}>
                        <div className="flex justify-center items-stretch gap-2.5 w-full">
                          <Tooltip title="Create an Account and Upload images">
                            <a
                              href="https://blume.omegaai.com/"
                              target="_blank"
                              className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                            >
                              Upload to Blume
                            </a>
                          </Tooltip>
                          <button
                            type="button"
                            onClick={() =>
                              canAddInvestigationFiles(patientMedicationInfo.rheumatologist_FILE) &&
                              rheumatologistFileRef.current?.click()
                            }
                            disabled={!canAddInvestigationFiles(patientMedicationInfo.rheumatologist_FILE)}
                            className={`flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff] ${
                              !canAddInvestigationFiles(patientMedicationInfo.rheumatologist_FILE)
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          >
                            <span>
                              <svg
                                width="11"
                                height="14"
                                viewBox="0 0 11 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
                                  fill="#FBFBFB"
                                />
                                <path
                                  d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
                                  fill="#FBFBFB"
                                />
                              </svg>
                            </span>
                            {uploadButtonLabel("rheumatologist_FILE")}
                            <input
                              key={investigationFileInputKey(
                                "rheumatologist_FILE",
                                patientMedicationInfo?.rheumatologist_FILE
                              )}
                              type="file"
                              multiple
                              name="rheumatologist_FILE"
                              onChange={handleFileChange}
                              ref={rheumatologistFileRef}
                              hidden
                            />
                          </button>
                          <Tooltip title="Mark as Uploaded">
                            <input
                              className="w-5 h-5"
                              type="checkbox"
                              value="uploaded"
                              checked={
                                patientMedicationInfo.rheumatologist.isUploaded
                              }
                              onChange={(e) => {
                                setPatientMedicationInfo({
                                  ...patientMedicationInfo,
                                  rheumatologist: {
                                    ...patientMedicationInfo.rheumatologist,
                                    isUploaded:
                                      !patientMedicationInfo.rheumatologist
                                        .isUploaded,
                                  },
                                });
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    {renderSelectedFileLine("rheumatologist_FILE")}
                    </div>

                    <div className={INVESTIGATION_ENTRY_CLASS}>
                    <div className="investigation-upload-row flex w-full">
                      <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD] flex items-center">
                        <h3 className="text-black font-[500] 2xl:text-[.9dvw] xl:text-[.9dvw] lg:text-[.9dvw] md:text-[.9dvw] text-[3.5vw]">
                          Internist
                        </h3>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              internist: {
                                ...patientMedicationInfo.internist,
                                name: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.internist.name}
                          placeholder="Enter Name"
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          placeholder="Enter Treatment"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              internist: {
                                ...patientMedicationInfo.internist,
                                treatment: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.internist.treatment}
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
                        <select
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              internist: {
                                ...patientMedicationInfo.internist,
                                painRelief: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.internist.painRelief}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        >
                          <option>Select</option>
                          <option>Pain relief 1</option>
                          <option>Pain relief 2</option>
                          <option>Pain relief 3</option>
                          <option>Pain relief 4</option>
                        </select>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          type="date"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              internist: {
                                ...patientMedicationInfo.internist,
                                date: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.internist.date}
                        />
                      </div>
                      <div className={INVESTIGATION_UPLOAD_COLUMN_WHITE}>
                        <div className="flex justify-center items-stretch gap-2.5 w-full">
                          <Tooltip title="Create an Account and Upload images">
                            <a
                              href="https://blume.omegaai.com/"
                              target="_blank"
                              className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                            >
                              Upload to Blume
                            </a>
                          </Tooltip>
                          <button
                            type="button"
                            onClick={() =>
                              canAddInvestigationFiles(patientMedicationInfo.internist_FILE) &&
                              internistFileRef.current?.click()
                            }
                            disabled={!canAddInvestigationFiles(patientMedicationInfo.internist_FILE)}
                            className={`flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff] ${
                              !canAddInvestigationFiles(patientMedicationInfo.internist_FILE)
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          >
                            <span>
                              <svg
                                width="11"
                                height="14"
                                viewBox="0 0 11 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
                                  fill="#FBFBFB"
                                />
                                <path
                                  d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
                                  fill="#FBFBFB"
                                />
                              </svg>
                            </span>
                            {uploadButtonLabel("internist_FILE")}
                            <input
                              key={investigationFileInputKey(
                                "internist_FILE",
                                patientMedicationInfo?.internist_FILE
                              )}
                              type="file"
                              multiple
                              name="internist_FILE"
                              onChange={handleFileChange}
                              ref={internistFileRef}
                              hidden
                            />
                          </button>
                          <Tooltip title="Mark as Uploaded">
                            <input
                              className="w-5 h-5"
                              type="checkbox"
                              value="uploaded"
                              checked={patientMedicationInfo.internist.isUploaded}
                              onChange={(e) => {
                                setPatientMedicationInfo({
                                  ...patientMedicationInfo,
                                  internist: {
                                    ...patientMedicationInfo.internist,
                                    isUploaded:
                                      !patientMedicationInfo.internist.isUploaded,
                                  },
                                });
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    {renderSelectedFileLine("internist_FILE")}
                    </div>

                    <div className={INVESTIGATION_ENTRY_CLASS}>
                    <div className="investigation-upload-row flex w-full">
                      <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD] flex items-center">
                        <h3 className="text-black font-[500] 2xl:text-[.9dvw] xl:text-[.9dvw] lg:text-[.9dvw] md:text-[.9dvw] text-[3.5vw]">
                          Physical Therapist
                        </h3>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              physicalTherapist: {
                                ...patientMedicationInfo.physicalTherapist,
                                name: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.physicalTherapist.name}
                          placeholder="Enter Name"
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          placeholder="Enter Treatment"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              physicalTherapist: {
                                ...patientMedicationInfo.physicalTherapist,
                                treatment: e.target.value,
                              },
                            });
                          }}
                          value={
                            patientMedicationInfo.physicalTherapist.treatment
                          }
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
                        <select
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              physicalTherapist: {
                                ...patientMedicationInfo.physicalTherapist,
                                painRelief: e.target.value,
                              },
                            });
                          }}
                          value={
                            patientMedicationInfo.physicalTherapist.painRelief
                          }
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        >
                          <option>Select</option>
                          <option>Pain relief 1</option>
                          <option>Pain relief 2</option>
                          <option>Pain relief 3</option>
                          <option>Pain relief 4</option>
                        </select>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          type="date"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              physicalTherapist: {
                                ...patientMedicationInfo.physicalTherapist,
                                date: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.physicalTherapist.date}
                        />
                      </div>
                      <div className={INVESTIGATION_UPLOAD_COLUMN_WHITE}>
                        <div className="flex justify-center items-stretch gap-2.5 w-full">
                          <Tooltip title="Create an Account and Upload images">
                            <a
                              href="https://blume.omegaai.com/"
                              target="_blank"
                              className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                            >
                              Upload to Blume
                            </a>
                          </Tooltip>
                          <button
                            type="button"
                            onClick={() =>
                              canAddInvestigationFiles(patientMedicationInfo.physical_FILE) &&
                              physicalFileRef.current?.click()
                            }
                            disabled={!canAddInvestigationFiles(patientMedicationInfo.physical_FILE)}
                            className={`flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff] ${
                              !canAddInvestigationFiles(patientMedicationInfo.physical_FILE)
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          >
                            <span>
                              <svg
                                width="11"
                                height="14"
                                viewBox="0 0 11 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
                                  fill="#FBFBFB"
                                />
                                <path
                                  d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
                                  fill="#FBFBFB"
                                />
                              </svg>
                            </span>
                            {uploadButtonLabel("physical_FILE")}
                            <input
                              key={investigationFileInputKey(
                                "physical_FILE",
                                patientMedicationInfo?.physical_FILE
                              )}
                              type="file"
                              multiple
                              name="physical_FILE"
                              onChange={handleFileChange}
                              ref={physicalFileRef}
                              hidden
                            />
                          </button>
                          <Tooltip title="Mark as Uploaded">
                            <input
                              className=" w-5 h-5"
                              type="checkbox"
                              value="uploaded"
                              checked={
                                patientMedicationInfo.physicalTherapist.isUploaded
                              }
                              onChange={(e) => {
                                setPatientMedicationInfo({
                                  ...patientMedicationInfo,
                                  physicalTherapist: {
                                    ...patientMedicationInfo.physicalTherapist,
                                    isUploaded:
                                      !patientMedicationInfo.physicalTherapist
                                        .isUploaded,
                                  },
                                });
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    {renderSelectedFileLine("physical_FILE")}
                    </div>

                    <div className={INVESTIGATION_ENTRY_CLASS}>
                    <div className="investigation-upload-row flex w-full">
                      <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD] flex items-center">
                        <h3 className="text-black font-[500] 2xl:text-[.9dvw] xl:text-[.9dvw] lg:text-[.9dvw] md:text-[.9dvw] text-[3.5vw]">
                          Neurologist
                        </h3>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          placeholder="Enter Name"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              neurologist: {
                                ...patientMedicationInfo.neurologist,
                                name: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.neurologist.name}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          placeholder="Enter Treatment"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              neurologist: {
                                ...patientMedicationInfo.neurologist,
                                treatment: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.neurologist.treatment}
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
                        <select
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              neurologist: {
                                ...patientMedicationInfo.neurologist,
                                painRelief: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.neurologist.painRelief}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        >
                          <option>Select</option>
                          <option>Pain relief 1</option>
                          <option>Pain relief 2</option>
                          <option>Pain relief 3</option>
                          <option>Pain relief 4</option>
                        </select>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          type="date"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              neurologist: {
                                ...patientMedicationInfo.neurologist,
                                date: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.neurologist.date}
                        />
                      </div>
                      <div className={INVESTIGATION_UPLOAD_COLUMN_WHITE}>
                        <div className="flex justify-center items-stretch gap-2.5 w-full">
                          <Tooltip title="Create an Account and Upload images">
                            <a
                              href="https://blume.omegaai.com/"
                              target="_blank"
                              className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                            >
                              Upload to Blume
                            </a>
                          </Tooltip>
                          <button
                            type="button"
                            onClick={() =>
                              canAddInvestigationFiles(patientMedicationInfo.neurologist_FILE) &&
                              neurologistFileRef.current?.click()
                            }
                            disabled={!canAddInvestigationFiles(patientMedicationInfo.neurologist_FILE)}
                            className={`flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff] ${
                              !canAddInvestigationFiles(patientMedicationInfo.neurologist_FILE)
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          >
                            <span>
                              <svg
                                width="11"
                                height="14"
                                viewBox="0 0 11 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
                                  fill="#FBFBFB"
                                />
                                <path
                                  d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
                                  fill="#FBFBFB"
                                />
                              </svg>
                            </span>
                            {uploadButtonLabel("neurologist_FILE")}
                            <input
                              key={investigationFileInputKey(
                                "neurologist_FILE",
                                patientMedicationInfo?.neurologist_FILE
                              )}
                              type="file"
                              multiple
                              name="neurologist_FILE"
                              onChange={handleFileChange}
                              ref={neurologistFileRef}
                              hidden
                            />
                          </button>
                          <Tooltip title="Mark as Uploaded">
                            <input
                              className="w-5 h-5"
                              type="checkbox"
                              value="uploaded"
                              checked={patientMedicationInfo.neurologist.isUploaded}
                              onChange={(e) => {
                                setPatientMedicationInfo({
                                  ...patientMedicationInfo,
                                  neurologist: {
                                    ...patientMedicationInfo.neurologist,
                                    isUploaded:
                                      !patientMedicationInfo.neurologist.isUploaded,
                                  },
                                });
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    {renderSelectedFileLine("neurologist_FILE")}
                    </div>

                    <div className={INVESTIGATION_ENTRY_CLASS}>
                    <div className="investigation-upload-row flex w-full">
                      <div className="py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white flex-1 rounded-s-full border-2 border-[#CDCDCD] flex items-center">
                        <h3 className="text-black font-[500] 2xl:text-[.9dvw] xl:text-[.9dvw] lg:text-[.9dvw] md:text-[.9dvw] text-[3.5vw]">
                          Psychiatrist / Psychologist
                        </h3>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          placeholder="Enter Name"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              psychiatrist: {
                                ...patientMedicationInfo.psychiatrist,
                                name: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.psychiatrist.name}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] border-l-0 bg-white border-2 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          placeholder="Enter Treatment"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              psychiatrist: {
                                ...patientMedicationInfo.psychiatrist,
                                treatment: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.psychiatrist.treatment}
                        />
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD]">
                        <select
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              psychiatrist: {
                                ...patientMedicationInfo.psychiatrist,
                                painRelief: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.psychiatrist.painRelief}
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                        >
                          <option>Select</option>
                          <option>Pain relief 1</option>
                          <option>Pain relief 2</option>
                          <option>Pain relief 3</option>
                          <option>Pain relief 4</option>
                        </select>
                      </div>
                      <div className="flex-1 py-4 px-3 2xl:min-w-[10dvw] xl:min-w-[10dvw] lg:min-w-[10dvw] md:min-w-[10dvw] min-w-[60dvw] bg-white border-2 border-l-0 border-[#CDCDCD] flex items-center">
                        <input
                          className="bg-transparent border-none outline-none focus:border-none active:border-none w-full"
                          type="date"
                          onChange={(e) => {
                            setPatientMedicationInfo({
                              ...patientMedicationInfo,
                              psychiatrist: {
                                ...patientMedicationInfo.psychiatrist,
                                date: e.target.value,
                              },
                            });
                          }}
                          value={patientMedicationInfo.psychiatrist.date}
                        />
                      </div>
                      <div className={INVESTIGATION_UPLOAD_COLUMN_WHITE}>
                        <div className="flex justify-center items-stretch gap-2.5 w-full">
                          <Tooltip title="Create an Account and Upload images">
                            <a
                              href="https://blume.omegaai.com/"
                              target="_blank"
                              className="flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff]"
                            >
                              Upload to Blume
                            </a>
                          </Tooltip>
                          <button
                            type="button"
                            onClick={() =>
                              canAddInvestigationFiles(patientMedicationInfo.psychiatrist_FILE) &&
                              psychiatristFileRef.current?.click()
                            }
                            disabled={!canAddInvestigationFiles(patientMedicationInfo.psychiatrist_FILE)}
                            className={`flex justify-center items-center w-full rounded-lg BTNGradientBg py-2 gap-1.5 text-[#fff] ${
                              !canAddInvestigationFiles(patientMedicationInfo.psychiatrist_FILE)
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                          >
                            <span>
                              <svg
                                width="11"
                                height="14"
                                viewBox="0 0 11 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.49935 0.333984L5.57735 0.338651C5.72616 0.3562 5.86472 0.423371 5.97067 0.529325C6.07663 0.63528 6.1438 0.77384 6.16135 0.922651L6.16602 1.00065V3.66732L6.16935 3.76732C6.19321 4.08477 6.32985 4.3832 6.55459 4.60867C6.77932 4.83414 7.07731 4.97176 7.39468 4.99665L7.49935 5.00065H10.166L10.244 5.00532C10.3928 5.02287 10.5314 5.09004 10.6373 5.19599C10.7433 5.30195 10.8105 5.44051 10.828 5.58932L10.8327 5.66732V11.6673C10.8327 12.1775 10.6378 12.6683 10.2878 13.0395C9.93785 13.4107 9.45928 13.6341 8.95002 13.664L8.83268 13.6673H2.16602C1.65588 13.6673 1.16501 13.4724 0.793842 13.1225C0.422678 12.7725 0.199277 12.2939 0.169349 11.7847L0.166016 11.6673V2.33398C0.165987 1.82384 0.360899 1.33297 0.710871 0.96181C1.06084 0.590646 1.53942 0.367246 2.04868 0.337318L2.16602 0.333984H5.49935Z"
                                  fill="#FBFBFB"
                                />
                                <path
                                  d="M10.1654 3.66733H7.49871L7.49805 1L10.1654 3.66733Z"
                                  fill="#FBFBFB"
                                />
                              </svg>
                            </span>
                            {uploadButtonLabel("psychiatrist_FILE")}
                            <input
                              key={investigationFileInputKey(
                                "psychiatrist_FILE",
                                patientMedicationInfo?.psychiatrist_FILE
                              )}
                              type="file"
                              multiple
                              name="psychiatrist_FILE"
                              onChange={handleFileChange}
                              ref={psychiatristFileRef}
                              hidden
                            />
                          </button>
                          <Tooltip title="Mark as Uploaded">
                            <input
                              className="w-5 h-5"
                              type="checkbox"
                              value="uploaded"
                              checked={patientMedicationInfo.psychiatrist.isUploaded}
                              onChange={(e) => {
                                setPatientMedicationInfo({
                                  ...patientMedicationInfo,
                                  psychiatrist: {
                                    ...patientMedicationInfo.psychiatrist,
                                    isUploaded:
                                      !patientMedicationInfo.psychiatrist.isUploaded,
                                  },
                                });
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    {renderSelectedFileLine("psychiatrist_FILE")}
                    </div>
                  </div>
                </div>
              </div>

              <div className="my-8">
                <h3 className="font-mainFont font-[600] text-[#333333] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.1vw] text-[3.5vw]">
                  Other Diagnostic Testing
                </h3>
                <div className="flex flex-col 2xl:flex-row xl:flex-row lg:flex-row md:flex-col justify-start w-full my-3 gap-3">
                  <div className="flex-1 flex flex-col gap-3">
                    <label className="font-mainFont font-[600] text-[#333333] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw]">
                      List the names of any previous pain management:
                    </label>
                    <input
                      onChange={(e) => {
                        setPatientMedicationInfo({
                          ...patientMedicationInfo,
                          namePreviousPain: e.target.value,
                        });
                      }}
                      value={patientMedicationInfo.namePreviousPain}
                      className="w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                      placeholder="Enter the names of any previous pain management method"
                    />
                  </div>
                  <div className="flex-1 flex flex-col gap-3">
                    <label className="font-mainFont font-[600] text-[#333333] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw]">
                      Physicians you have seen in the past:
                    </label>
                    <input
                      className="w-full px-6 py-3 rounded-full border outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0]"
                      placeholder="Enter the names of any previous Physicians"
                      value={patientMedicationInfo.physiciansHaveSeen}
                      onChange={(e) => {
                        setPatientMedicationInfo({
                          ...patientMedicationInfo,
                          physiciansHaveSeen: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <style jsx>{`
         {
          /* .BTNGradientBg {
          background: linear-gradient(90deg, #0A1E44 0%, #2E4A7D 100%);
        } */
        }

        .shadowsForMainWrapper {
          box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
        }

        .relative {
          position: relative;
        }

        .tooltip {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          background: #333333;
          color: white;
          padding: 6px 12px;
          border-radius: 4px;
          font-size: 0.9vw;
          font-family: "mainFont", sans-serif;
          font-weight: 400;
          white-space: nowrap;
          visibility: hidden;
          opacity: 0;
          transition: visibility 0s linear 0.3s, opacity 0.3s ease-out;
          margin-top: 8px;
          z-index: 10;
        }

        .relative:hover .tooltip,
        .relative:active .tooltip {
          visibility: visible;
          opacity: 1;
          transition: visibility 0s linear, opacity 0.3s ease-out;
        }

        @media (max-width: 768px) {
          .my-2 {
            width: 100%;
          }

          p.font-mainFont {
            font-size: 3vw;
          }

          button.text-[1vw] {
            font-size: 3vw;
            padding: 8px 16px;
          }

          h3.text-[1.4dvw] {
            font-size: 3.5vw;
          }

          h3.text-[.9dvw] {
            font-size: 2.5vw;
          }

          input.text-[1vw],
          select.text-[1vw],
          label.text-[1vw] {
            font-size: 3vw;
          }

          .min-w-[10dvw] {
            min-width: 15vw;
          }

          .tooltip {
            font-size: 2.5vw;
            padding: 4px 8px;
          }

        }

        @media (max-width: 480px) {
          .relative {
            flex-shrink: 0;
          }

          .tooltip {
            font-size: 3.5vw;
            padding: 3px 6px;
            margin-top: 4px;
          }

          .flex.items-center.justify-between {
            flex-direction: column;
            align-items: flex-start;
            gap: 1rem;
          }

          p.font-mainFont {
            font-size: 4vw;
          }

          button.text-[1vw] {
            font-size: 4vw;
            padding: 6px 12px;
          }

          h3.text-[1.4dvw] {
            font-size: 4.5vw;
          }

          h3.text-[.9dvw] {
            font-size: 3.5vw;
          }

          input.text-[1vw],
          select.text-[1vw],
          label.text-[1vw] {
            font-size: 4vw;
          }

          .min-w-[10dvw] {
            min-width: 20vw;
          }
        }
      `}</style>
    </>
  );
};
